<template>
  <div class="modal-icon-wrapper" :class="classes">
    <i v-if="icon" :class="`icon-${icon}`"></i>
    <slot />
    <img
      src="@/assets/images/stars.svg"
      class="image-stars"
      :class="{ 'image-stars-icon': !!icon }"
    />
  </div>
</template>
<script>
export default {
  props: {
    classes: {
      type: [String, Object],
      default: "mb-9 mt-5"
    },
    icon: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.modal-icon-wrapper {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 24px;
  background: linear-gradient(
    148.5deg,
    rgba($color: #ee6469, $alpha: 0.2) -19.31%,
    rgba($color: #9155ec, $alpha: 0.2) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: #9155ec;
    font-size: 38px;
  }

  .image-stars {
    position: absolute;
    top: -10%;
    right: -30%;
    width: 25%;
    max-height: 40px;
    @media screen and (max-width: 991px) {
      right: 20%;
    }
  }

  .image-stars-icon {
    position: absolute;
    top: -10%;
    right: -30%;
    width: 25%;
    max-height: 40px;
    @media screen and (max-width: 991px) {
      right: 20%;
    }
  }

  i {
    font-size: 45px;
    color: $primary;
  }
}
</style>
